import { League } from '../../entities/index.js';

const anyLeague = function(league) {
    return league instanceof League;
};

export default anyLeague;